import React from 'react';

type ChoosePlanHeaderProps = {
  description?: string;
};

const ChoosePlanHeader = ({ description }: ChoosePlanHeaderProps) => {
  return (
    <div className="mb-32 text-center sm:mb-48">
      <h1 className="mb-16 mt-0 font-suisse-works text-headline-md text-black xs:text-headline-lg sm:text-headline-lg">
        Choose the plan that’s right for you
      </h1>
      <h3 className="m-0 font-suisse-neue text-body-lg xs:text-[16px]">
        {description ||
          'Join high-powered tech and business leaders who read The Information every day.'}
      </h3>
    </div>
  );
};

export default ChoosePlanHeader;
